import { Delete } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, IconButton } from "@mui/material";
import type { FC, MouseEvent } from "react";
import { InHouseTooltip } from "../InHouseTooltip/InHouseTooltip";

type Props = {
	onEdit: (event: MouseEvent<HTMLElement>) => void;
	onDelete: (event: MouseEvent<HTMLElement>) => void;
	onMenuOpen: (event: MouseEvent<HTMLElement>) => void;
};

export const PtoRowActions: FC<Props> = ({ onEdit, onDelete, onMenuOpen }) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
		<InHouseTooltip title="Edit">
			<IconButton size="small" onClick={onEdit} sx={{ p: "2px", color: "#4D5579", "&:hover": { color: "#1976d2" } }}>
				<EditIcon sx={{ fontSize: "18px" }} />
			</IconButton>
		</InHouseTooltip>
		<InHouseTooltip title="Remove">
			<IconButton size="small" onClick={onDelete} sx={{ p: "2px", color: "#4D5579", "&:hover": { color: "#d32f2f" } }}>
				<Delete sx={{ fontSize: "18px" }} />
			</IconButton>
		</InHouseTooltip>
		<IconButton size="small" onClick={onMenuOpen} sx={{ p: "2px", transition: "opacity 0.1s ease-in-out" }}>
			<MoreVertIcon sx={{ fontSize: "20px" }} />
		</IconButton>
	</Box>
);
